import { ComponentStyleConfig } from '@chakra-ui/react';

export const Checkbox: ComponentStyleConfig = {
  baseStyle: {
    control: {
      bg: 'neutral.50',
      width: '20px',
      height: '20px',
      borderRadius: '5px',
      borderColor: 'neutral.600',
      _checked: {
        bg: 'primary.500',
        borderColor: 'primary.500',
        backgroundColor: 'primary.500',
        _hover: {
          bg: 'primary.500',
          backgroundColor: 'primary.500',
          borderColor: 'primary.500',
        },
        _focusVisible: {
          boxShadow: 'none',
          borderColor: 'primary.500',
          backgroundColor: 'primary.500',
        },
      },
    },
  },
};
